(function () {
  function getSlides(viewer) {
    return Array.from(viewer.querySelectorAll('.product__media-item')).filter((el) => {
      if (el.classList.contains('product__media-item--variant')) return false;
      if (el.matches('[data-gang-option]:not(.gang__active)')) return false;
      if (el.clientWidth === 0 || getComputedStyle(el).display === 'none') return false;
      return true;
    });
  }

  function getActiveIndex(slides) {
    if (!slides.length) return 0;

    const active = slides.findIndex((slide) => slide.classList.contains('is-active'));
    return active >= 0 ? active : 0;
  }

  function initPilgrimProductGallery() {
    const mediaGallery = document.querySelector('.product--pilgrim media-gallery');
    if (!mediaGallery) return;

    const viewer = mediaGallery.querySelector('product-gallery');
    if (!viewer) return;

    const prevBtn = viewer.querySelector('button[name="previous"]');
    const nextBtn = viewer.querySelector('button[name="next"]');
    const mql = window.matchMedia('(min-width: 750px)');

    function updateDesktopArrows() {
      if (!prevBtn || !nextBtn || !mql.matches) return;

      const slides = getSlides(viewer);
      const index = getActiveIndex(slides);

      prevBtn.toggleAttribute('disabled', index <= 0);
      nextBtn.toggleAttribute('disabled', index >= slides.length - 1);
    }

    function goToSlide(index) {
      const slides = getSlides(viewer);
      const slide = slides[index];
      if (!slide) return;

      mediaGallery.setActiveMedia(slide.dataset.mediaId, false, false);
      updateDesktopArrows();
    }

    function patchViewerUpdate() {
      if (!viewer.update || viewer.__pilgrimPatched) return;

      const originalUpdate = viewer.update.bind(viewer);
      viewer.update = function () {
        originalUpdate();

        if (mql.matches) {
          updateDesktopArrows();
        }
      };

      viewer.__pilgrimPatched = true;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', (event) => {
        if (!mql.matches) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const slides = getSlides(viewer);
        const index = getActiveIndex(slides);
        if (index > 0) goToSlide(index - 1);
      }, true);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (event) => {
        if (!mql.matches) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const slides = getSlides(viewer);
        const index = getActiveIndex(slides);
        if (index < slides.length - 1) goToSlide(index + 1);
      }, true);
    }

    viewer.addEventListener('slideChanged', () => {
      if (mql.matches) {
        updateDesktopArrows();
      }
    });

    mediaGallery.querySelector('[id^="GalleryThumbnails"]')?.addEventListener('click', () => {
      requestAnimationFrame(updateDesktopArrows);
    });

    mql.addEventListener('change', updateDesktopArrows);

    patchViewerUpdate();
    updateDesktopArrows();

    window.setTimeout(() => {
      patchViewerUpdate();
      updateDesktopArrows();
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPilgrimProductGallery);
  } else {
    initPilgrimProductGallery();
  }
})();
